// extracted by mini-css-extract-plugin
export default {"container":"tableAssociationAdminsStyle_container__+YH14","service":"tableAssociationAdminsStyle_service__EFcGB"};